import WideResumePDF from './Resumes/ResumeWidePDF.js';
import MobileResumePDF from './Resumes/ResumeMobilePDF.js';
import MessageSuccess from './MessageSuccess.js';
import GameModals from './GameModals.js';
import Page404Modal from './404Modal.js';
import DefaultModal from './DefaultModal.js';
const { Demo_1Player, Demo_2Player, Demo_Capstone } = GameModals; 

export default {
    WideResumePDF,
    MobileResumePDF,
    MessageSuccess,
    Demo_1Player,
    Demo_2Player,
    Demo_Capstone,
    Page404Modal,
    DefaultModal
}